"use client";

import { useLocation } from "@tanstack/react-router";
import { useState } from "react";

import { EntityAboutCards } from "@/components/catalog-entity/entity-about-cards";
import { EntityAboutPanel } from "@/components/catalog-entity/entity-about-panel";
import type { EntityAboutSection } from "@/components/catalog-entity/entity-about-section";

interface EntityAboutProps {
  /** Stable id used for the panel element and its tabs. */
  id: string;
  entityName: string;
  sections: EntityAboutSection[];
}

/** Preview cards plus the About panel they open, for artist and company pages. */
export function EntityAbout({ id, entityName, sections }: EntityAboutProps) {
  const [activeKey, setActiveKey] = useState<string | null>(null);
  const pathname = useLocation({ select: (location) => location.pathname });
  const [openedAt, setOpenedAt] = useState(pathname);

  // Same-route navigations (artist → similar artist) keep this instance mounted,
  // so close the panel whenever the page it was opened on changes.
  if (openedAt !== pathname) {
    setOpenedAt(pathname);
    setActiveKey(null);
  }
  const panelId = `entity-about-${id}`;
  const cardSections = sections.filter((section) => section.loading || section.count > 0);
  const panelSections = cardSections.filter((section) => !section.loading);

  return (
    <>
      <EntityAboutCards panelId={panelId} sections={cardSections} onOpen={setActiveKey} />
      <EntityAboutPanel
        panelId={panelId}
        entityName={entityName}
        sections={panelSections}
        activeKey={activeKey}
        onTabChange={setActiveKey}
        onClose={() => setActiveKey(null)}
      />
    </>
  );
}
